import React from 'react';

// import Scss
import './assets/scss/themes.scss';

// imoprt Route
import Route from './Routes';
import "primeicons/primeicons.css";

/*
 * Import Firebase Configuration file
 * import { initFirebaseBackend } from "./helpers/firebase_helper";
 */

// Fake Backend
import { ToastContainer } from 'react-toastify';

// Activating fake backend
// fakeBackend();

/*
 * const firebaseConfig = {
 *   apiKey: process.env.REACT_APP_APIKEY,
 *   authDomain: process.env.REACT_APP_AUTHDOMAIN,
 *   databaseURL: process.env.REACT_APP_DATABASEURL,
 *   projectId: process.env.REACT_APP_PROJECTID,
 *   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
 *   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
 *   appId: process.env.REACT_APP_APPID,
 *   measurementId: process.env.REACT_APP_MEASUREMENTID,
 * };
 */

// // init firebase backend

// initFirebaseBackend(firebaseConfig);

function App() {
    return (
        <React.Fragment>
            <ToastContainer
                theme="colored"
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={false}
                limit={0}
            />
            <Route />
        </React.Fragment>
    );
}

export default App;
